import React from 'react';
import { useNav } from '../../hx/useNav';
import { useTranslation } from '../../hx/useTranslation';
import GxList from '../../gx/GxList';
import * as FxLog from '../../fx/FxLog';
import { clearStore, StoreSettSecUser } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import { useWindowSize } from '../../hx/useWindowSize';


const MxSettSecUserList = (props) => {
  const [{ trans }] = useTranslation();
  const size = useWindowSize();
  const [{ navTo }] = useNav();

  const [storeSettSecUser, setStoreSettSecUser] = useSessionStorage('StoreSettSecUser', StoreSettSecUser);
  const r_list = React.useRef(null);

  React.useEffect(() => {
    clearStore('StoreSettSecUser', storeSettSecUser);
    formLoad();
    // eslint-disable-next-line
  }, []);

  const formLoad = async () => {
  }

  const openForm = async (op, row) => {
    if (row === null) {
      storeSettSecUser.inUser = null;
    } else {
      storeSettSecUser.inUser = row.original.inUser;
    }
    setStoreSettSecUser(storeSettSecUser);
    navTo("sett-sec-user-form");
  }

  const getTableColumns = () => {
    let cols = [];
    try{
      let id = -1;
      if (size.isLarge) { // PANTALLA GRANDE
        cols.push({ id: id++, Header: "ID", accessor: "inUser", show: false });
        cols.push({ id: id++, Header: trans('field.user'), accessor: "txUser", highlight: true, width: '50%' });
        cols.push({ id: id++, Header: trans('field.group'), accessor:  row => (row["txType"]==='E' && row["txSecGroup"]), width: '50%' }); // no muestro xq si es un Cliente, no debe verse del grupo Master.
        
      } else { // PANTALLA PEQUEÑA
        cols.push({ id: id++, Header: "ID", accessor: "inUser", show: false });
        cols.push({ id: id++, Header: trans('field.user'), accessor: "txUser", highlight: true, width: '50%' });
        cols.push({ id: id++, Header: trans('field.group'), accessor:  row => (row["txType"]==='E' && row["txSecGroup"]), width: '50%' }); // no muestro xq si es un Cliente, no debe verse del grupo Master.
        
      }

      cols.push({ id: "B", Header: "is_client", accessor: row => Boolean(row["txType"]==='C'), show: false });

    } catch(error) {
      FxLog.errorx('MxSettSecUserList.getTableColumns', error)
    }
    return cols;
  }

  return (
    <div>
      <GxList
        moduleName={trans('field.users')}
        xref={r_list}
        tooltip={`${trans('field.user')}`}
        fullscreen
        url="sett/sec/users"
        filter={`n_user.txType='${'E'}'`}
        onOpenForm={openForm}
        columns={getTableColumns()}
      />

    </div>
  );
}

export default MxSettSecUserList;
